var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLikeThumb = function SvgLikeThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1551,7.38923207 L14.4544,12.2479321 C14.1237,12.5724321 13.9359,13.0197321 13.9359,13.4845321 L13.9359,22.2460321 C13.9359,23.2107321 14.7404,24.0000321 15.7237,24.0000321 L20.7295,24.0000321 C21.4446,24.0000321 22.0882,23.5790321 22.3653,22.9388321 L25.2794,16.2647321 C26.0392,14.5282321 24.743,12.5987321 22.8212,12.5987321 L19.5585,12.5987321 L20.4077,8.58193207 C20.4971,8.14343207 20.363,7.69613207 20.0412,7.38043207 C19.5138,6.87173207 18.6735,6.87173207 18.1551,7.38923207 Z M9.2877,24.0000321 C10.271,24.0000321 11.0755,23.2107321 11.0755,22.2460321 L11.0755,15.2298321 C11.0755,14.2650321 10.271,13.4757321 9.2877,13.4757321 C8.3045,13.4757321 7.5,14.2650321 7.5,15.2298321 L7.5,22.2460321 C7.5,23.2107321 8.3045,24.0000321 9.2877,24.0000321 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgLikeThumb);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/like-thumb.760c28aa062aa5c2b1648e84e6740e94.svg";